import apiCall from "../services/ApiServerCall";

export const updatePassword =  (requestData) => {
    return  apiCall().post('/users/update/password',requestData).then(({data}) => data);
}
